module.exports = __webpack_public_path__ + "img/TRY.9461bafc.png";